<template>
  <v-dialog v-model="dialogShow" persistent width="520" height="285" class="dialog">
    <v-card>
      <v-card-title class="dialogTitle">
        <p class="dialogTitle-title">另存为文件</p>
        <v-spacer></v-spacer>
        <p @click="closeDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text style="padding:41px 48px 30px 39px;">
        <div style="display:flex;align-items:center;">
          <p style="font-size:16px;color:#000000;">文件名</p>
          <v-text-field v-model="folderName" dense outlined hide-details width="339" height="36" style="margin-left:46px;"></v-text-field>
        </div>
        <p :style="{'visibility':errorShow ? 'visible' : 'hidden'}" style="margin-left:93px;margin-top:5px;font-size:14px;color:#ff0000;"><span class="iconfontFamily">&#xe71f;</span>{{errorText}}</p>
        <div style="margin-top:49px;text-align:right;">
          <v-btn @click="resaveFolder" width="100" height="33" dark color="#1E3A8A">保存</v-btn>
        </div>
      </v-card-text>
    </v-card>

  </v-dialog>
</template>

<script>
export default {
  name: "ResaveGlobeOperationFolder",
  props:["dialogShow"],
  data(){
    return{

      folderName:"",

      errorShow:false,
      errorText:"",


    }

  },
  methods:{
    closeDialog(){
      this.$emit("closeDialog","")
    },


    //获取可用的另存为文件夹名称
    getResaveName(){
      this.$axios({
        method:"get",
        url:"/authorApi/z-geo-file/getAutoFileName",
        params:{
          fileName:this.$store.state.currFolderName
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.status === 200){
          this.folderName = resultData.data
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });
    },


    //另存为文件夹
    resaveFolder(){
      if(this.folderName.length > 30){
        this.errorText = "文件名超出30字"
        this.errorShow = true;
      }
      else if(this.folderName.trim().length === 0){
        this.errorText = "文件名不能为空"
        this.errorShow = true;
      }
      else{
        let data = new FormData()
        data.append('fileId',this.$store.state.currFolderId)
        data.append('fileName',this.folderName)
        this.$axios.post("/authorApi/z-geo-file/fileSaveAs",data).then((resultData)=>{
          resultData = resultData.data;
          console.log(resultData)
          if(resultData.status === 200){
            this.$emit("resaveFolderOk",resultData.data.fileId)
          }
          else if(resultData.status === 308){
            this.errorText = "已存在同名文件"
            this.errorShow = true;
          }
          else{
            this.$store.state.snackbarShow=true
            this.$store.state.snackbarText = resultData.message
            this.$store.state.snackbarType = 'error'
            this.$emit("resaveFolderFailed")
          }
        }).catch(()=>{
          this.$store.state.snackbarShow=true
          this.$store.state.snackbarText = "暂无权限，请联系创建者"
          this.$store.state.snackbarType = 'error'
        });
      }






    }



  },
  mounted(){
    this.getResaveName()
  }

}
</script>

<style scoped>

</style>
